/* eslint-disable react-hooks/exhaustive-deps */
import { useReducer, useMemo, memo, useEffect, useCallback } from 'react';
import GeneralContext from './GeneralContext';
import initialGeneralState from './initialGeneralState';
import generalReducer from 'contexts/general/reducer/general.reducer';
import * as action from 'contexts/general/reducer/general.actions';
import { useTranslation } from 'react-i18next';
import { IChildrenProps } from 'interfaces/general.interface';
import { useAuth0 } from '@auth0/auth0-react';
import * as GeneralTypes from './reducer/general.types';

function GeneralProvider(props: IChildrenProps) {
  const [general, dispatch] = useReducer(generalReducer, initialGeneralState);
  const { t: translate } = useTranslation();
  const { getAccessTokenSilently } = useAuth0();

  useEffect(() => {
    (async () => {
      if (!general.ping) return false;
      const token = await getAccessTokenSilently();
      return await action.getExchangesAction({ dispatch, translate, token });
    })();
  }, [general.ping]);

  useEffect(() => {
    (async () => {
      if (!general.ping) return false;
      const token = await getAccessTokenSilently();
      return await action.getCountriesAction({ dispatch, translate, token });
    })();
  }, [general.ping]);

  useEffect(() => {
    (async () => {
      if (!general.ping) return false;
      const token = await getAccessTokenSilently();
      return await action.getAssociationStatesAction({ dispatch, translate, token });
    })();
  }, [general.ping]);

  useEffect(() => {
    (async () => {
      if (!general.ping) return false;
      const token = await getAccessTokenSilently();
      return await action.getPointsOfSaleCategoriesAction({ dispatch, token });
    })();
  }, [general.ping]);

  const setPing = useCallback((value: boolean) => {
    dispatch({
      type: GeneralTypes.SET_PING,
      payload: value,
    });
  }, []);

  const memoProvider = useMemo(
    () => ({
      ...general,
      setPing,
    }),
    [general, setPing]
  );

  return (
    <GeneralContext.Provider value={memoProvider}>
      {props.children}
    </GeneralContext.Provider>
  );
}

export default memo(GeneralProvider);
